<template>
  <div class="right_box_main">
    <div class="listBox-item">
      <!-- 面包屑 -->
      <!-- <div class="mianbao">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/twoNetworkConvergence' }">两网融合</el-breadcrumb-item>
                    <el-breadcrumb-item>考情管理</el-breadcrumb-item>
                    <el-breadcrumb-item>申请管理</el-breadcrumb-item>
                    <el-breadcrumb-item>加班管理</el-breadcrumb-item>
                </el-breadcrumb>
            </div> -->
      <!-- 表格 -->
      <el-card class="publicCard">
        <!-- 搜索框 -->
        <div>
          <el-form
            :inline="true"
            class="demo-form-inline"
            size="mini"
          >
            <el-form-item
              label="所属机构"
              prop="orgName"
            >
              <el-cascader
                v-model="searchlist.orgId"
                :options="orgList"
                @change="handleChange"
                :show-all-levels="false"
              ></el-cascader>
              <!-- <el-input v-model="orgName" placeholder></el-input> -->
            </el-form-item>
            <el-form-item
              label="加班类型"
              prop="region"
            >
              <el-select
                v-model="searchlist.workOvertimeType"
                placeholder="请选择"
              >
                <el-option
                  label="周末加班"
                  value="1"
                ></el-option>
                <el-option
                  label="节假日加班"
                  value="2"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="searchlistdata"
              >查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button
                type="info"
                @click="searchlistReset"
              >重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- 表格主体 -->
        <div class="listBox-item">
          <el-button
            class="mb16"
            type="primary"
            size="mini"
            @click="showDialog('','add')"
          >+ 新增</el-button>
          <div class="table_card">
            <el-table
              :data="tableData"
              :header-cell-style="{ background: '#f8fafa' }"
              size="small"
              border
              align="center"
              current-row-key
              highlight-current-row
            >
              <el-table-column
                label="序号"
                type="index"
                width="50"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="title"
                label="标题"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="orgName"
                label="所属机构"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="workOvertimeType"
                label="加班类型"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span v-if="tableData[scope.$index].workOvertimeType==1">周末加班</span>
                  <span v-if="tableData[scope.$index].workOvertimeType==2">节假日加班</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="source"
                label="来源"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span v-if="tableData[scope.$index].source==1">app</span>
                  <span v-if="tableData[scope.$index].source==2">平台</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="startTime"
                label="加班开始时间"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="endTime"
                label="加班结束时间"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="applyReason"
                label="加班原因"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="leaveTimeLength"
                label="时长（小时)"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                align="center"
                prop
                label="操作"
                min-width='120'
              >
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="light"
                    content="审核"
                    placement="top-start"
                  >
                    <button
                      @click="examineDialog(scope.row.id)"
                      class="tabBtn iconfont icon-shenpi shenhe"
                      v-if="scope.row.approvalStatus==0"
                    ></button>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="light"
                    content="查看"
                    placement="top-start"
                  >
                    <button
                      @click="lookDialog(scope.row.id)"
                      class="tabBtn iconfont icon-chakan shenhe"
                    ></button>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="light"
                    content="删除"
                    placement="top-start"
                  >
                    <button
                      class="tabBtn el-icon-delete tabBtn-delete"
                      @click="deleteDialog(scope.row.id)"
                    ></button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
              :page-size="pageConfig.pageSize"
              layout="total, prev, pager, next, jumper"
              @current-change="handleCurrentChange"
              :total="pageConfig.total"
            ></el-pagination>
          </div>
        </div>
      </el-card>

      <!-- 审核对话框 -->
      <el-dialog
        title="审核"
        :visible.sync="examineDialogVisible"
        width="35%"
      >
        <el-form
          ref="examineForm"
          :model="examine"
          label-width="140px"
        >
          <el-form-item label="姓名:">
            <el-input
              v-model="examine.applyName"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="所属机构:">
            <el-input
              v-model="examine.orgName"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="加班类型:">
            <el-input
              v-model="examine.workOvertimeType"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="开始时间:">
            <el-input
              v-model="examine.startTime"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="结束时间:">
            <el-input
              v-model="examine.endTime"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="加班时长（小时）:">
            <el-input
              v-model="examine.leaveTimeLength"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="加班原因:">
            <el-input
              v-model="examine.applyReason"
              type="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item label="审批人:">
            <el-input
              v-model="examine.approvalName"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="状态:">
            <el-input
              v-model="examine.approvalStatus"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            label="审核意见:"
            style="margin-bottom:20px"
          >
            <p style='color:red;font-size:12px'>此项为审核不通过时必填项,审核通过可忽略此项 !</p>
            <el-input
              v-model="examine.suggestion"
              type="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              @click="shenhe(examine.id,'2')"
              type="primary"
            >审核通过</el-button>
            <el-button
              @click="shenhe(examine.id,'1')"
              type="info"
            >审核不通过</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <!-- 查看对话框 -->
      <el-dialog
        title="查看"
        :visible.sync="lookDialogVisible"
        width="35%"
      >
        <el-form
          ref="examineForm"
          :model="examine"
          label-width="140px"
        >
          <el-form-item label="姓名:">
            <el-input
              v-model="examine.applyName"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="所属机构:">
            <el-input
              v-model="examine.orgName"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="加班类型:">
            <el-input
              v-model="examine.workOvertimeType"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="开始时间:">
            <el-input
              v-model="examine.startTime"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="结束时间:">
            <el-input
              v-model="examine.endTime"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="加班时长（小时）:">
            <el-input
              v-model="examine.leaveTimeLength"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="加班原因:">
            <el-input
              v-model="examine.applyReason"
              type="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item label="审批人:">
            <el-input
              v-model="examine.approvalName"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="状态:">
            <el-input
              v-model="examine.approvalStatus"
              disabled
            ></el-input>
          </el-form-item>
        </el-form>
      </el-dialog>

      <!-- 新增对话框 -->
      <el-dialog
        :title="add.title"
        :visible.sync="add.off"
        width="35%"
      >
        <el-form
          label-width="140px"
          ref="baseForm"
          :model="add.form"
          :rules="ruleArr"
        >
          <el-form-item
            label="标题:"
            prop="title"
          >
            <el-input v-model="add.form.title"></el-input>
          </el-form-item>
          <el-form-item
            label="组织机构:"
            prop="orgId"
          >
            <orgListSelect
              v-model="add.form.orgId"
              :on-success="onSuccess"
              style="width:100%"
            />
            <!-- <el-input v-model="examine.orgId"></el-input> -->
          </el-form-item>
          <el-form-item
            label="人员姓名："
            prop="personId"
          >
            <el-select
              v-model="add.form.personId"
              placeholder="请选择人员"
              ref="personName"
              multiple
              style="width:100%"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="加班类型:"
            prop="workOvertimeType"
          >
            <el-select
              v-model="add.form.workOvertimeType"
              placeholder="请选择"
            >
              <el-option
                label="周末加班"
                value="1"
              ></el-option>
              <el-option
                label="节假日加班"
                value="2"
              ></el-option>
            </el-select>
            <!-- <el-input v-model="examine.workOvertimeType"></el-input> -->
          </el-form-item>
          <el-form-item
            label="加班开始时间:"
            prop="startTime"
          >
            <el-date-picker
              v-model="add.form.startTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
            ></el-date-picker>
            <!-- <el-input v-model="examine.startTime"></el-input> -->
          </el-form-item>
          <el-form-item
            label="加班结束时间:"
            prop="endTime"
          >
            <el-date-picker
              v-model="add.form.endTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
            ></el-date-picker>
            <!-- <el-input v-model="add.form.endTime"></el-input> -->
          </el-form-item>
          <el-form-item
            label="时长:"
            prop="leaveTimeLength"
          >
            <el-input v-model="add.form.leaveTimeLength"></el-input>
          </el-form-item>
          <el-form-item
            label="通知方式:"
            prop="notice"
          >
            <el-radio
              v-model="add.form.notice"
              label="1"
              value="1"
            >短信</el-radio>
            <el-radio
              v-model="add.form.notice"
              label="2"
              value="2"
            >公众号</el-radio>
            <!-- <el-input v-model="examine.applyReason" type="textarea"></el-input> -->
          </el-form-item>
          <el-form-item
            label="内容:"
            prop="content"
          >
            <el-input
              v-model="add.form.content"
              type="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="onSubmit"
            >{{add.title}}</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { post } from "@/api/requrestHttp"
import orgListSelect from "@/component/orgListSelect/index.vue"
// 表格数据和分页js
import { tabdata } from "@/mixins/tabledataMix.js"
// 表单校验js
import { validatePhoneOrMobile } from "@/utils/validate.js"
export default {
  components: { orgListSelect },
  mixins: [tabdata],
  data() {
    return {
      searchlist: {
        orgId: [],
        // workOvertimeType: "",
      },
      applyType: 6,
      applyName: "",
      // approvalStatus: "",
      // workOvertimeType: "",
      time: [],
      tableData: [],
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1,
      },
      ruleArr: {
        issueType: [
          {
            required: true,
            message: "请输入纠纷类型名称",
            trigger: "blur",
          },
        ],
      },
      type: "",
      userOptions: [],
      tableDataUrl: "",
      // 审核弹框显示隐藏
      examineDialogVisible: false,
      lookDialogVisible: false,
      addDialogVisible: false,
      // 重新赋值需要绑定
      examine: {
        // approvalStatus: "",
        workOvertimeType: "",
      },
      add: {
        form: {
          // title: "",
          orgId: [],
          // personId: "",
          // startTime: "",
          // endTime: "",
          // leaveTimeLength: "",
          // notice: "",
          // workOvertimeType: "",
          // content: ""
        },
        off: false,
      },
      rules: {
        suggestion: [
          {
            required: true,
            message: "请输入审核不通过原因",
            trigger: "blur",
          },
          {
            min: 1,
            max: 100,
            message: "长度在 1到 100 个字符",
            trigger: "blur",
          },
        ],
      },
      orgList: [],
    }
  },
  methods: {
    // 查询功能
    async getData() {
      let res = await this.$http.post(
        "/admin/attendance/apply/info/list",
        //这个参数对比下接口文档
        {
          pageNo: 1,
          pageSize: 10,
          applyTypeList: [6],
          // applyName: this.searchlist.applyName,
          // workOvertimeType: this.workOvertimeType,
          // orgName: this.orgName,
        }
      )
      if (res.code !== 200) {
        this.$message.error("查询数据失败")
      }
      this.$message.success("查询数据成功")
      this.tableData = res.content.list
      // this.getPageDatas();
    },

    // 操作=》审核
    async examineDialog(id) {
      this.examineDialogVisible = true
      let res = await this.$http.post("/admin/attendance/apply/info/get", {
        id: id,
      })
      console.log(res)
      if (res.code !== 200) {
        this.$message.error("获取数据失败")
      }
      this.$message.success("获取数据成功")
      this.examine = res.content
      console.log(123 + this.examine.photo)
      // 判断加班类型
      const exValue = this.examine.workOvertimeType
      if (exValue == 1) {
        this.examine.workOvertimeType = "周末加班"
      } else if (exValue == 2) {
        this.examine.workOvertimeType = "节假日加班"
      }

      if (
        res.content.leaveTimeLength != null &&
        res.content.leaveTimeLength != undefined
      ) {
        res.content.leaveTimeLength = (+res.content.leaveTimeLength).toFixed(2)
      }

      // 判断状态类型
      const eaValue = this.examine.approvalStatus
      if (eaValue == 0) {
        this.examine.approvalStatus = "待审核"
      } else if (eaValue == 1) {
        this.examine.approvalStatus = "审核不通过"
      } else if (eaValue == 2) {
        this.examine.approvalStatus = "审核通过"
      }
      this.getPageDatas("", "leave")
    },

    async lookDialog(id) {
      this.lookDialogVisible = true
      let res = await this.$http.post("/admin/attendance/apply/info/get", {
        id: id,
      })
      if (res.code !== 200) {
        this.$message.error("获取数据失败")
      }
      this.$message.success("获取数据成功")
      this.examine = res.content
      // 判断加班类型
      const exValue = this.examine.workOvertimeType
      if (exValue == 1) {
        this.examine.workOvertimeType = "周末加班"
      } else if (exValue == 2) {
        this.examine.workOvertimeType = "节假日加班"
      }

      if (
        res.content.leaveTimeLength != null &&
        res.content.leaveTimeLength != undefined
      ) {
        res.content.leaveTimeLength = (+res.content.leaveTimeLength).toFixed(2)
      }

      // 判断状态类型
      const eaValue = this.examine.approvalStatus
      if (eaValue == 0) {
        this.examine.approvalStatus = "待审核"
      } else if (eaValue == 1) {
        this.examine.approvalStatus = "审核不通过"
      } else if (eaValue == 2) {
        this.examine.approvalStatus = "审核通过"
      }
      this.getPageDatas("", "leave")
    },
    // 操作=》审核=》通过&&未通过
    async shenhe(id, status) {
      if (status == 1 && this.examine.suggestion == null) {
        this.$message.success("请输入审核不通过原因")
        return
      }
      let res = await this.$http.post("/admin/attendance/apply/info/verify", {
        id: id,
        approvalStatus: status,
      })
      if (res.code !== 200) {
        this.$message.error("审批数据失败")
      }
      this.$message.success("审批数据成功")
      this.examineDialogVisible = false
      this.getPageDatas("", "leave")
    },
    // 操作==》删除
    async deleteDialog(id) {
      const confirmResult = await this.$confirm(
        "此操作将永久删除该用户, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err)
      if (confirmResult !== "confirm") {
        return this.$message.info("已经取消删除")
      }
      let res = await this.$http.post("/admin/attendance/apply/info/delete", {
        id: id,
      })
      console.log(res)
      if (res.code !== 200) {
        this.$message.error("删除数据失败")
      }
      this.$message.success("删除数据成功")
      this.getPageDatas("", "leave")
    },
    onSubmit() {
      this.$refs.baseForm.validate((valid) => {
        if (valid) {
          if (this.type == "add") {
            // console.log(this.add.form.orgId[this.add.form.orgId.lenght - 1])
            post("/admin/attendance/apply/info/leave", {
              ...this.add.form,
              personIds: this.add.form.personId,
              // orgId: this.add.form.orgId[
              //     this.add.form.orgId.length - 1
              // ],
              // startTime: "",
              applyType: 6,
              // applyTypeList: [6],
              personId: "",
              // streetId: Number(this.add.form.orgId[0]),
              // communityId:
              //     this.add.form.orgId.length >= 2
              //         ? Number(this.add.form.orgId[1])
              //         : "",
              // gridId:
              //     this.add.form.orgId.length >= 3
              //         ? Number(this.add.form.orgId[2])
              //         : ""
            }).then((res) => {
              this.add.off = false
              this.$message.success("新增成功")
              this.getPageDatas("", "leave")
            })
          }
        } else {
          //   console.log("error submit!!");
          return false
        }
      })
    },
    showDialog(row, type) {
      this.type = type
      switch (type) {
        case "add":
          this.add.off = true
          this.add.title = "新增"
          this.add.form = {
            orgId: [],
          }
          break
      }
    },
    onSuccess(info) {
      this.getUser(info.value)
    },
    //获取人员
    getUser(id) {
      this.userOptions = []
      post("/admin/user/info/list", {
        orgId: id,
        pageNo: 1,
        pageSize: 99,
      }).then((res) => {
        res.content.list.forEach((e) => {
          this.userOptions.push({
            value: e.id,
            label: e.name,
          })
        })
      })
    },
    // 所属机构
    handleChange(value) {
      if (value != null) {
        this.orgId = value[value.length - 1]
      }
    },
  },
  created() {
    post("/rbac/admin/org/info/OrgTreelist", { orgType: 1,isValid: 1, }).then((res) => {
      this.orgList = res.content
    })
  },
  mounted() {
    // this.initTableDataUrl("/admin/attendance/apply/info/list",'','leave');
  },
  watch: {
    tableData(newName, oldName) {
      console.log("1数据" + newName)
      console.log("2数据" + oldName)
    },
  },
}
</script>

<style lang="less" scoped>
.shenhe {
  color: red;
  &:hover {
    color: skyblue;
  }
}
</style>
